<script lang="ts">
    import ReportsPage from '@Reports/Reports/Pages/ReportsPage'
    export default ReportsPage
</script>

<template>
    <div>
        <ReportBuilder :viewModel="reportBuilder"
                       @create-report="handleCreateReportCommand" />
        
        <ReportEditor :viewModel="reportEditor" 
                      @update-report="handleUpdateReportCommand" />

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Reports</h1>
                </div>
                <div class="col-lg-6 text-right">
                    <button role="button" class="btn btn-success mr-1" style="padding: 0.7em 2em;" @click="showReportCreator">Create report</button>

                    <a class="btn btn-outline-secondary btn-lg" href="https://www.transparentchoice.com/user-guide/reports" title="User guide: Report results" target="_blank">
                        <i class="fa fa-info" aria-hidden="true"></i>
                    </a>

                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 60px;" />


        <div class="container">
            <h3 v-if="!rm"><i class="fa fa-spinner fa-spin"></i> Loading... </h3>
            <div v-if="rm">

                <div class="row">
                    <div class="col-lg-4 offset-lg-8">
                        <div class="input-group input-group-lg">
                            <input type="search" placeholder="Search for a report..." class="form-control" v-model="SearchPhrase">
                            <span class="input-group-append">
                                <span class="input-group-text"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i></span>
                            </span>
                        </div>
                    </div>
                </div>

                <table class="table table-bordered table-hover table-browser mt-3">
                    <thead>
                        <tr>
                            <th class="sortable" @click="OrderByNameCommand" :class="{'selected': OrderBy === 'name'}">
                                <span class="text-uppercase font-weight-normal">Name</span>

                                <span class="fa-stack">
                                    <i class="fa fa-sort-asc fa-stack-1x" :class="{'selected': (OrderBy === 'name' && OrderByDescending === false)}"></i>
                                    <i class="fa fa-sort-desc fa-stack-1x" :class="{'selected' : (OrderBy === 'name' && OrderByDescending === true)}"></i>
                                </span>
                            </th>
                            <th class="sortable text-center" style="width: 180px;" @click="OrderByModifiedCommand" :class="{'selected': OrderBy === 'modified'}">

                                <span class="text-uppercase font-weight-normal">Updated on</span>

                                <span class="fa-stack">
                                    <i class="fa fa-sort-asc fa-stack-1x" :class="{'selected' : (OrderBy === 'modified' && OrderByDescending === false)}"></i>
                                    <i class="fa fa-sort-desc fa-stack-1x" :class="{'selected' : (OrderBy === 'modified' && OrderByDescending === true)}"></i>
                                </span>
                            </th>
                            <th class="sortable text-center" style="width: 180px;" @click="OrderByCreatedCommand" :class="{'selected': OrderBy === 'created'}">

                                <span class="text-uppercase font-weight-normal">Created on</span>

                                <span class="fa-stack">
                                    <i class="fa fa-sort-asc fa-stack-1x" :class="{'selected' : (OrderBy === 'created' && OrderByDescending === false)}"></i>
                                    <i class="fa fa-sort-desc fa-stack-1x" :class="{'selected' : (OrderBy === 'created' && OrderByDescending === true)}"></i>
                                </span>
                            </th>
                            <th style="width: 90px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="r in ReportsView" :key="r.ReportId">
                            <td>
                                <a class="text-dark" v-sanitizedHref="url_ReportViewPage(r.ReportId)">
                                    <span>{{r.Name}}</span>
                                </a>
                            </td>
                            <td class="text-center">
                                <span>{{getFormattedDateStr(r.Modified)}}</span><br />
                                <small>{{getFormattedTimeStr(r.Modified)}}</small>
                            </td>
                            <td class="text-center">
                                <span>{{getFormattedDateStr(r.Created)}}</span><br />
                                <small>{{getFormattedTimeStr(r.Created)}}</small>
                            </td>
                            <td>
                                <div class="dropdown">
                                    <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                        Actions
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item" :href="`/#/sharing/resource/ReportsDataShareResourceProvider/${r.ReportId}`">Share</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" @click="showReportEditor(r)">Edit</a>
                                        <a class="dropdown-item" @click="handleCloneReportCommand(r)">Clone</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" @click="handleDeleteReportCommand(r)">Delete</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
